import moment from 'src/app/utils/moment';

export interface ICardioProgramDetail {
    id: string;
    title: string,
    createdBy?: string;
    creationDate?: string;
    startDate: string,
    startDateHidden?: boolean;
    endDate?: string,
    endDateHidden?: boolean;
    programs: any[],
    notes?: string[],
    readNotes?: boolean,
    isPremium?: boolean;
}

export interface ICardioSession {
    exercise: string;
    notes: string;
    measurement: number;
    measurementType: string;
    timingOther?: string;
    typeOther?: string;
    type: 'hiit' | 'liss' | 'other';
    timing: 'fasted' | 'preTraining' | 'postTraining' | 'other';
}

export interface CardioCategory {
    id: string;
    title: string;
    sessions: any[];
    notes?: string;
}

export class  CardioProgram {
    id: string = null;
    title: string = null;
    comments: any[] = [];
    startDate: string = null;
    startDateHidden?: boolean = null;
    endDate?: string = null;
    endDateHidden?: boolean = null;
    programs: any[] = [{days: []}];
    createdBy: string = null;
    creationDate: string = null;
    lastModifiedBy: string = null;
    lastModifiedDate: string = null;
    notes: string[] = [];
    draftCardioProgram: any;
    published?: string;
    organization: string;
    readNotes:boolean;
    isPremium?: boolean;

    constructor (init: Partial<CardioProgram>){
        Object.assign(this, init);
    }

    isPublished(): boolean {
        return this.hasOwnProperty("published")
    }

    hasDraft(): boolean {
        return this.hasOwnProperty("draftCardioProgram");
    }

    clone(): CardioProgram {
        return Object.assign({}, this);
    }

    cloneActive(): ICardioProgramDetail {
        const toReturn = {
            id: this.id,
            title: this.title,
            startDate: this.startDate,
            startDateHidden: this.startDateHidden,
            createdBy: this.createdBy,
            creationDate: this.creationDate,
            endDate: this.endDate,
            endDateHidden: this.endDateHidden,
            programs: this.programs,
            notes: this.notes,
            isPremium: this.isPremium
        }
        return JSON.parse(JSON.stringify(toReturn))
    }

    cloneDraft(): ICardioProgramDetail {
        let obj = Object.assign({}, this.draftCardioProgram);
        // Fallback for browser bug
        obj.title = obj.title || this.title;
        obj.notes = obj.notes || this.notes;
        obj.createdBy = this.createdBy || null,
        obj.creationDate = this.creationDate || null,
        obj.id = this.id;
        return obj
    }

    isStartDateValid() {
        return !this.startDate || !this.startDateHidden || (moment as any)().isSameOrAfter((moment as any)(this.startDate))
      }
        
    
      isEndDateValid() {
          return !this.endDate || !this.endDateHidden || (moment as any)().isSameOrBefore((moment as any)(this.endDate))
      }

    getStatus() {
        if(this.hasDraft()) {
            return "draft"
        } else if(!this.isEndDateValid()) {
            return "expired"
        } else if((moment as any)(this.startDate).isAfter((moment as any)())) {
            return "scheduled"
        } else {
            return "published"
        }
    }
}